"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapService = function () {
	function MapService() {
		_classCallCheck(this, MapService);
	}

	_createClass(MapService, [{
		key: "construct",
		value: function construct($canvas, settings) {}
	}, {
		key: "setType",
		value: function setType(type) {}
	}, {
		key: "getCenter",
		value: function getCenter() {}
	}, {
		key: "setCenter",
		value: function setCenter(center) {}
	}, {
		key: "setZoom",
		value: function setZoom(zoom) {}
	}, {
		key: "getZoom",
		value: function getZoom() {}
	}, {
		key: "addPins",
		value: function addPins(pins) {}
	}, {
		key: "geocode",
		value: function geocode(query) {}
	}, {
		key: "getPinsWithinRange",
		value: function getPinsWithinRange(lat, lng, rangeInMeters) {}
	}, {
		key: "getPinClosestTo",
		value: function getPinClosestTo(lat, lng) {}
	}, {
		key: "getPinDistance",
		value: function getPinDistance(lat, lng, pin) {}
	}, {
		key: "highlightPin",
		value: function highlightPin(pin) {}
	}, {
		key: "fitPins",
		value: function fitPins(pins) {}
	}, {
		key: "updatePinVisibility",
		value: function updatePinVisibility(pin) {}
	}, {
		key: "locate",
		value: function locate() {}
	}, {
		key: "redraw",
		value: function redraw() {}
	}]);

	return MapService;
}();

;

module.exports = MapService;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/map-services/map-service.js
// module id = 16
// module chunks = 0